export enum analyticsEnum {
	form_start_finance_quote = 'form_start_finance_quote',
	form_interaction_finance_quote = 'form_interaction_finance_quote',
	form_view_finance_quote = 'form_view_finance_quote',
	form_submit_finance_quote = 'form_submit_finance_quote',
	view_tpr_adjust = 'view_tpr_adjust',
	view_tpr_summary = 'view_tpr_summary',
	click_secondary_interaction = 'click_secondary_interaction',

	// made up because not in docs
	form_submit_feedback_survey = 'form_submit_feedback_survey',
	form_submit_exit_survey = 'form_submit_exit_survey',
	form_submit_preapproval_callback = 'form_submit_preapproval_callback',
	form_submit_preapproval_survey = 'form_submit_preapproval_survey',// not used anymore
	form_submit_research_survey = 'form_submit_research_survey',
	form_submit_survey = 'form_submit_survey',

}
export const analyticsEnumObj = Object.freeze(analyticsEnum);
export enum preApprovalEnums {
	save = 'save',
	pre = 'pre',
	progress = 'Open-InProgress',
	approved = 'Open-Approved',
	notapproved = 'Open-NotApproved',
	expired = 'Resolved-Expired',
	converted = 'Resolved-Converted',
	ineligible = 'Open-Ineligible',
	closed = 'Resolved-Closed'
}
export const preApprovalEnumsObj = Object.freeze(preApprovalEnums);
export const formInteractionNameValues = {
	customerVerifiedThroughOtp: "customer verified through otp",
	firstName: "customer first name",
	lastName: "customer last name",
	fakePostcode: "customer postcode",
	address: "customer address",
	unitNo: "customer unit no.",
	streetNo: "customer street no.",
	streetName: "customer street name",
	streetType: "customer street type",
	suburb: "customer suburb",
	postcode: "customer postcode",
	state: "customer state",
	dd: "customer date of birth day",
	mm: "customer date of birth month",
	yyyy: "customer date of birth year",
	licenceNumber: "customer licence number",
	origin: "customer licence origin",
	livingArrangement: "customer living arrangement",
	investmentProperty: "customer investment property",
	fsl: "customer full service lease",
	dealership: "customer preferred dealership",
	expectingToPurchase: "customer expecting to purchase",
	contactMethod: "customer contact method",
	email: "customer email",
	phone: "customer phone",
	terms: "customer terms and conditions"
};
export enum EOfferType
{
	FinanceText = 1,
	VehicleText = 3,
	VehiclePrice = 4
}
export enum EOfferTypePillText
{
	FinanceText = 'Finance Offer',
	VehicleText = 'Offer',
	VehiclePrice = 'Driveaway Offer'
}
export enum EFlow
{
	campaign = 'campaign',
	businessCampaign = 'business-campaign',
	indicative = 'indicative',
	business = 'business',
	getTpr = 'get-tpr',
	adjustTpr = 'adjust-tpr',
	cash = 'cash'
}
export enum EFinaceToggleTypes
{
	cash = 'cash',
	finance = 'finance'
}
